import { HomePageActionBase } from "./home-page-base-action";
import { HomePageActionDialogReturnObj, PerformActionParamObj } from "../extras";
import { IHomePageAction } from "./i-home-page-action";

export class DeleteFormsAction extends HomePageActionBase implements IHomePageAction {

    public getTitle() {
        return "Delete Forms";
    }

    public permissionsRequiredToPerform(): string {
        return "CanDeleteForm"
    }

    public performAction(paramObj: PerformActionParamObj): Promise<HomePageActionDialogReturnObj> {
        this.message = "Deleting selected Form(s)...";
        // TODO: need to create an endpoint to delete multiple
        let ids = this.formInstanceGridRows.map(x => x.Id).join(',');

        return this.formInstanceService.deleteAll(ids).then(x => {
            return new HomePageActionDialogReturnObj();
        });
    }
}
